import React from 'react';
import ConfirmationCard from '../ConfirmationCards';

const ConfirmationPhones: React.FC<{
  phones: GQL.IPhoneConfirmation[];
  selectedId:  string | number | null;
  setSelectedId: React.Dispatch<React.SetStateAction< string | number | null>>;
}> = ({ phones, selectedId, setSelectedId }) => {
  return (
    <div>
      {phones.map((phone) => (
        <ConfirmationCard
          contentCardText={`(${phone.ddd}) ${phone.numero}`}
          setOption={setSelectedId}
          id={phone.codigo!}
          selectedId={selectedId}
        />
      ))}
    </div>
  );
};

export default ConfirmationPhones;
